import { render, staticRenderFns } from "./Endorsments.vue?vue&type=template&id=3b8f0d0c&scoped=true&"
import script from "./Endorsments.vue?vue&type=script&lang=js&"
export * from "./Endorsments.vue?vue&type=script&lang=js&"
import style0 from "./Endorsments.vue?vue&type=style&index=0&id=3b8f0d0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f0d0c",
  null
  
)

export default component.exports